import { Heart } from "@phosphor-icons/react";

export const DisclaimerBanner = () => (
  <div className="w-full bg-[#F4F1E8] border-b border-[#EAE6D9]" data-testid="disclaimer-banner">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-2 text-center">
      <Heart size={14} weight="fill" className="shrink-0 text-[#8A9A86]" />
      <span className="text-xs sm:text-sm text-[#6D7A6A] font-medium">
        We're not licensed therapists — just humans trying to make light in dark situations.
      </span>
    </div>
  </div>
);
